import timeZonePickerView from './timeZonePickerComponent.html';
import './timeZonePickerComponent.css';
import _ from 'lodash';

export function timeZonePickerComponent() {
	return {
		bindings: {
			model: '=',
		},
		controllerAs: 'vm',
		controller: timeZonePickerComponentCtrl,
		template: timeZonePickerView,
	};
}

export class timeZonePickerComponentCtrl {
	/**
	 * Save injections and bind functions
	 * @param {object} $scope
	 * @param {TimeZoneService} TimeZone
	 */
	constructor($scope, $timeout, TimeZone) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.TimeZone = TimeZone;
		// bind functions
		this.setChoiceFromModel = this.setChoiceFromModel.bind(this);
	}

	/**
	 * Setup
	 * @return {Promise<void>}
	 */
	async $onInit() {
		// fetch timezone data options
		const data = await this.TimeZone.getData();
		this.timezones = data.map(tz => ({ id: tz.id, $search: tz.name }));
		// handle model initial value and watch for model change
		this.setChoiceFromModel();
		this.$scope.$watch('vm.model', this.setChoiceFromModel);
	}

	/**
	 * Called when model changes
	 */
	setChoiceFromModel() {
		this.$timeout(() => {
			this.chosenTz = _.find(this.timezones, { id: this.model }) || _.find(this.timezones, { id: 'America/New_York' });
		});
	}

	/**
	 * Called when user changes selection
	 */
	setModelFromUser(choice) {
		this.model = choice.id;
	}
}
